export default {
  desktop_access:
    'Diperlukan Akses Seluler<br/><br/>Untuk pengalaman Dompet Bitcash yang lancar, silakan beralih ke perangkat seluler Anda. Kami menyarankan Anda menggunakan versi terbaru browser seluler Anda.<br/><br/> Termasuk browser yang didukung',
  desktop_access_2:
    'Untuk kompatibilitas dan keamanan penuh, selalu perbarui browser dan perangkat seluler Anda.',
}
